"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATGameScene = exports.Depth = void 0;
const ATAudioScene_1 = require("./ATAudioScene");
const ATSceneNames_1 = require("./ATSceneNames");
const ATTextButton_1 = require("./ATTextButton");
const Game_1 = require("./Game");
const KHContainer_1 = require("./KH/KHContainer");
const KHRandom_1 = require("./KH/KHRandom");
var Depth;
(function (Depth) {
    Depth[Depth["UI"] = 4] = "UI";
    Depth[Depth["Fluff"] = 1] = "Fluff";
    Depth[Depth["Background"] = 0] = "Background";
})(Depth = exports.Depth || (exports.Depth = {}));
// Seconds
const WIN_TIME = 60 * 60;
// Millis
const RAND_MIN = 5 * 1000;
const RAND_MAX = 10 * 60 * 1000;
const FIRST_TIME_RAND_MAX = 10 * 1000;
class ATGameScene extends Phaser.Scene {
    init(data) {
        this.timeout = (data === null || data === void 0 ? void 0 : data.timeout) || 1000;
        console.log('Timeout', this.timeout);
    }
    constructor() {
        super(ATSceneNames_1.default.Game);
    }
    create() {
        this.input.on('pointerdown', () => {
            if (this.over && this.time.now > this.leaveTime) {
                this.scene.start(ATSceneNames_1.default.Menu);
            }
        });
        new KHContainer_1.KHContainer(this, 0, 0, Game_1.game.width, Game_1.game.height, 0xFFFFFF, 1);
        this.random = new KHRandom_1.KHRandomGeneral();
        this.instructionText = this.add.dom(Game_1.game.width / 2, Game_1.game.height * 0.16, 'div', Game_1.game.fontStyle(0.1 * Game_1.game.height), "Press the button when it appears.").setOrigin(0.5, 0.5);
        this.timerText = this.add.dom(Game_1.game.width / 2, Game_1.game.height * 0.9, 'div', Game_1.game.fontStyle(0.1 * Game_1.game.height), "").setOrigin(0.5, 0.5);
        this.button = new ATTextButton_1.default(this, Game_1.game.width / 2 - 200, Game_1.game.height / 2 - 50, 400, 100, 'Press');
        this.button.setVisible(false);
        this.button.on('pointerdown', () => {
            ATAudioScene_1.ATAudioScene.Shared.playSfx('click');
            this.button.setVisible(false);
            if (this.buttonClickTimer) {
                this.buttonClickTimer.remove();
                this.buttonClickTimer = null;
            }
        });
        this.time.addEvent({
            delay: 4000,
            callback: () => {
                this.setInstruction('');
            }
        });
        this.start();
    }
    startButtonTimer(firstTime = false) {
        if (!this.inProgress)
            return;
        const delay = this.random.nextFloat(RAND_MIN, firstTime ? FIRST_TIME_RAND_MAX : RAND_MAX);
        this.time.addEvent({
            delay,
            callback: () => {
                this.showButton();
            }
        });
    }
    showButton() {
        if (!this.inProgress)
            return;
        this.button.setVisible(true);
        this.button.setInteractable(true);
        this.buttonClickTimer = this.time.addEvent({
            delay: this.timeout,
            callback: () => {
                this.lose();
            }
        });
        this.startButtonTimer();
    }
    start() {
        this.over = false;
        this.timePassed = 0;
        this.inProgress = true;
        this.setTime(this.timePassed);
        this.startButtonTimer(true);
    }
    setInstruction(text) {
        this.instructionText.setText(text);
    }
    setTime(time) {
        if (time < 0)
            time = 0;
        const hours = Math.floor((time / 3600));
        const minutes = Math.floor((time / 60) % 60);
        const seconds = Math.floor(time % 60);
        this.timerText.setText(`${hours.toString().padStart(1, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
    }
    lose() {
        ATAudioScene_1.ATAudioScene.Shared.playSfx('buzzer');
        this.button.setVisible(false);
        this.setInstruction('The button was not pressed.');
        this.finishGame();
    }
    win() {
        this.setInstruction('You pressed the button every time.');
        Game_1.game.achievements.unlock(Game_1.ATAchievements.Win);
        this.finishGame();
    }
    finishGame() {
        this.leaveTime = this.time.now + 1000;
        this.button.setInteractable(false);
        this.inProgress = false;
        this.over = true;
    }
    update(_, delta) {
        if (!this.inProgress)
            return;
        this.timePassed += delta / 1000;
        this.setTime(this.timePassed);
        if (this.timePassed >= WIN_TIME) {
            this.win();
        }
    }
}
ATGameScene.MAX_TIME = 20;
exports.ATGameScene = ATGameScene;
